<template>
	<div class="app" :class="($store.state.mode === 'dark') ? 'app-dark' : 'false'">
		<menuBar :disable="$route.name == 'landingPage' " :class="$store.state.mode"/>
		<transition name="slide">
			<keep-alive v-if="$store.state.currentUser">
				<router-view></router-view>
			</keep-alive>
			<router-view v-else></router-view>
		</transition>
	</div>
</template>
<script>
import menuBar from './components/menuBar.vue'
/* eslint-disable */
export default {
	name: 'app',
	components: {
		menuBar,
	},
	data() {
		return {
		}
	},
	created() {
		if (!localStorage.mode) {
			localStorage.mode = 'light' 
			this.$store.commit('setMode', localStorage.mode);
		} else {
			this.$store.commit('setMode', localStorage.mode);
		}
	}
};
</script>
<style lang="scss">
$base-color: #1b7b46;
$inner-color: #caefe2;
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	-webkit-touch-callout: none;
	-webkit-user-select: none;
	-html-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	scroll-behavior: smooth;
}
html {
	background-color: #000;
}
body {
	font-size: 62.5%;
	/*overscroll-behavior-y: contain;*/
}
.app.app-dark {
	background-color: #000;
	color: #fff;
}
.app {
	font-family: 'GoogleSans';
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	overflow-x: hidden;
	width: 100vw;
	height: 100vh;
	background-color: #fff;
	color: #000;
}
.userpage.userpage-dark {
	background-color: #000;
	color: #fff;
}
.userpage {
	position: absolute;
	width: 100%;
	padding-bottom: 3.4rem;
	background-color: #fff;
	color: #000;
}
.heading {
	margin: 2.5rem 1.5rem .7rem !important;
	.title {
		font-size: 24px;
		font-weight: bold;
		letter-spacing: -.02rem;
		opacity: .95;
	}
	.subtitle {
		font-size: 10px;
		opacity: .5;
	}
}
.navbar.dark-header-active {
	backdrop-filter: blur(1px);
	background-image: linear-gradient(rgb(0,0,0), transparent);
}
.navbar.false {
	background-image: linear-gradient(rgb(255,255,255), rgb(255,255,255));
	box-shadow: 0 1px 10px rgba(0,0,0, .03);
}
.navbar {
	z-index: 99;
	position: fixed;
	width: 100%;
	height: 4rem;
	padding: 0 1.5rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	.title {
		font-size: 14px;
	}
}
.audio-list--wrapper {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.5rem !important;
	border-bottom: 1px solid rgba(255,255,255, .1);
	&.active {
		background: linear-gradient(90deg, rgba($base-color, 0.35), transparent);
	}
	.image--wrapper {
		transition: 1s;
		&:active {
			opacity: .5;
		}
		.image-profile {
			width: 75px;
			height: 75px;
			border-radius: 18px;
			background-size: cover;
			background-position: center;
		}
	}
	.content--wrapper {
		width: 100%;
		height: 70px;
		font-size: 10px;
		padding: 0 1rem;
		display: flex;
		flex-flow: column;
		justify-content: space-between;
		transition: 1s;
		&:active {
			opacity: .5;
		}
		.creator--wrapper {
			display: flex;
			align-items: center;
			.name {
				opacity: 0.7;
				padding: 0 .2rem 0rem 0rem;
			}
			.verified--wrapper {
				height: 10px;
				display: flex;
				align-items: center;
				.verify {
					height: 10px;
				}
			}
		}
		.title {
			letter-spacing: 0.01rem;
		}
		.date.dark-date {
			opacity: 0.5;
		}
		.date.false {
			opacity: 0.7;
		}
		.date {
			font-weight: normal;
			.dot {
				margin: 1px 2px;
				width: 3px;
				height: 3px;
				background-color: rgba($base-color, 1);
				border-radius: 50%;
				display: inline-block;
				&.active {
					animation: pulsate 1.5s ease-out;
					animation-iteration-count: infinite;
					opacity: 1;
					@-webkit-keyframes pulsate {
						0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
						50% {opacity: 1.0;}
						100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
					}
				}
			}
		}
	}
	.play--wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
.audio-card--wrapper {
	width: 100vw;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	overflow-x: auto;
	padding: .7rem 1rem !important;
	margin: 0 !important;
	.img--wrapper {
		max-width: 165px;
		padding: 0 .5rem;
	}	
	.img--wrapper:last-child {
		max-width: 225px;
		padding-right: 5% !important;
	}
	.ripple {
		border-radius: 22px;
		height: 150px;
		.image-audio {
			display: flex;
			justify-content: flex-end;
			width: 150px;
			height: 150px;
			background-position: center;
			border-radius: 22px;
			transition: .4s;
			background-size: cover;
			.duration--wrapper {
				display: flex;
				align-self: flex-end;
				align-items: center;
				justify-content: center;
				.duration {
					display: flex;
					align-items: center;
					justify-content: center;
					background: rgba(0,0,0, .5);
					color: white;
					font-size: 10px;
					padding: .6rem;
					margin: .5rem;
					border-radius: 12px;
					.play {
						padding: 0 0 0 .5rem;
						display: flex;
						transition: 0.25s ease-in-out;
						i {
							font-size: 15px;
						}
						&:active {
							opacity: 0.75;
							transform: scale(0.90);
						}
					}
				}
			}
		}
	}
	.content--wrapper{
		width: 100%;
		padding-top: .75rem;
		text-align: center;
		display: flex;
		flex-direction: column;
		line-height: 1.4;
		font-size: 10px;
		.title {
			&.active {
				display: flex;
				-webkit-mask-image:linear-gradient(90deg, transparent, rgba(0,0,0,1) 20% 70%,transparent);
			}
		}
		.creator--wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			.verified {
				height: 10px;
				margin-left: .15rem;
				display: flex;
				align-self: center;
			}
			/*for category*/
			.creator-cat {
				opacity: .5;
				text-transform: capitalize;
			}
			.verified-cat--wrapper {
				height: 10px;
				margin-left: .15rem;
				display: flex;
				align-items: center;
				.verify-cat {
					height: 10px;
				}
			}
		}
		.subtitle {
			opacity: .5;
			text-transform: capitalize;
		}
	}
}
.submenu--wrapper {
	padding: 5rem 1.5rem 0 !important;
	.title {
		font-size: 16px;
		font-weight: bold;
	}
	.desc {
		font-size: 10px;
		opacity: 0.7;
	}
	.body-content {
		margin-top: 20px;
		text-align: justify;
		.sub-title {
			font-size: 10px;
			letter-spacing: .020rem;
			.features {
				padding: .25rem 0;
			}
		}
	}
	.dot {
		margin: 2px 2px;
		height: 4px;
		width: 4px;
		background-color: rgb(36, 179, 131);
		border-radius: 50%;
		display: inline-block;
	}
}
/* MATERIAL ICON */
@font-face {
	font-family: 'Material Icons';
	font-style: normal;
	font-weight: 400;
	src: url(https://fonts.gstatic.com/s/materialicons/v47/flUhRq6tzZclQEJ-Vdg-IuiaDsNc.woff2) format('woff2');
}
.material-icons {
	font-family: 'Material Icons';
	font-weight: normal;
	font-style: normal;
	font-size: 24px;
	line-height: 1;
	letter-spacing: normal;
	text-transform: none;
	display: inline-block;
	white-space: nowrap;
	word-wrap: normal;
	direction: ltr;
	-webkit-font-feature-settings: 'liga';
	-webkit-font-smoothing: antialiased;
}
/* EL-MESSAGE */
.el-message-box {
	width: auto !important;
}
.el-message {
	font-family : 'GoogleSans';
	background-color: #edffee !important;
	border-color: #edffee !important;
	p {
		margin-left: 10px !important;
	}
}
/*SLIDE TRANSITION*/
.slide-enter-active {
	transition: all .3s ease-in-out;
	position: fixed;
	top: 0px;
}
.slide-leave-active {
	transition: all .3s ease-in-out;
	position: fixed;
	top: 0px;
}
.slide-enter
/* .slide-leave-active below version 2.1.8 */ {
	transform: translateX(100vw);
	opacity: 0;
}
.slide-enter-to
/* .slide-leave-active below version 2.1.8 */ {
	opacity: 1;
	transform: translateX(0vw);
}
.slide-leave
/* .slide-leave-active below version 2.1.8 */ {
	opacity: 1;
	transform: translateX(0vw);
}
.slide-leave-to
/* .slide-leave-active below version 2.1.8 */ {
	opacity: 0;
	transform: translateX(-100vw);
}
/* Typeface .truetype*/
@font-face {
	font-family: 'GoogleSans';
	src:  url('assets/typo/GoogleSans-Regular.ttf') format('truetype');
	font-weight: normal;
	font-style: normal;
	font-display: fallback;
}
@font-face {
	font-family: 'GoogleSans';
	src:  url('assets/typo/GoogleSans-Medium.ttf') format('truetype');
	font-weight: medium;
	font-style: normal;
	font-display: fallback;
}
@font-face {
	font-family: 'GoogleSans';
	src:  url('assets/typo/GoogleSans-Bold.ttf') format('truetype');
	font-weight: bold;
	font-style: normal;
	font-display: fallback;
}
</style>
